/* eslint-disable react/jsx-no-useless-fragment */
import { useMutation } from "@apollo/client";
import ToggleArchivedOnFinancialsTemplateMutation from "components/financials/modern/graphql/ToggleArchivedOnFinancialsTemplateMutation";
import type {
  IToggleArchivedOnFinancialsTemplateMutation,
  IToggleArchivedOnFinancialsTemplateMutationVariables,
} from "components/financials/modern/graphql/__generated__/ToggleArchivedOnFinancialsTemplateMutation.generated";
import type { IFinancialsTemplateFieldsFragment } from "components/financials/modern/graphql/fragments/__generated__/FinancialsTemplateFieldsFragment.generated";
import { SimpleTextTooltip } from "components/ui/Tooltip";
import classNames from "components/ui/classNames";
import { ArchiveIcon, Undo2Icon } from "lucide-react";
import { useIntl } from "react-intl";

interface ToggleArchivedButtonProps {
  template: IFinancialsTemplateFieldsFragment;
  onToggleArchived?: () => void;
}
export default function ToggleArchivedButton({ template, onToggleArchived }: ToggleArchivedButtonProps) {
  const intl = useIntl();
  const [toggleArchivedOnFinancialsTemplate, { loading }] = useMutation<
    IToggleArchivedOnFinancialsTemplateMutation,
    IToggleArchivedOnFinancialsTemplateMutationVariables
  >(ToggleArchivedOnFinancialsTemplateMutation, {
    onCompleted: onToggleArchived,
  });

  const isArchived = !!template.archivedAt;

  return (
    <SimpleTextTooltip
      content={
        isArchived
          ? intl.formatMessage({
              defaultMessage: "Restaurar",
              id: "LTm6tU",
              description: "Restore template action",
            })
          : intl.formatMessage({ defaultMessage: "Arquivar", id: "ToNV1d", description: "Archive template action" })
      }
    >
      <button
        type="button"
        disabled={loading}
        className={classNames(
          "group relative inline-flex h-10 items-center p-2",
          "rounded-l-xl border border-slate-200 bg-slate-50/60 text-slate-600",
          "dark:border-slate-950 dark:bg-slate-700",
          "focus-visible:outline-none",
          "focus-visible:ring-1 focus-visible:ring-offset-1",
          "focus-visible:ring-gray-100 focus-visible:ring-offset-gray-300",
          "focus-visible:border-transparent focus-visible:bg-gray-50",
          "dark:focus-visible:ring-slate-950 dark:focus-visible:ring-offset-transparent",
          "disabled:cursor-not-allowed disabled:opacity-50",
          {
          "hover:bg-rose-50 hover:text-rose-600": !isArchived,
          "hover:bg-violet-50 hover:text-violet-600": isArchived,
        })}
        onClick={() => {
          toggleArchivedOnFinancialsTemplate({
            variables: {
              objectId: template.objectId,
            },
          });
        }}
      >
        {isArchived ? <Undo2Icon className="h-4 w-4 text-current" /> : <ArchiveIcon className="h-4 w-4 text-current" />}
      </button>
    </SimpleTextTooltip>
  );
}
